import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [activeTab, setActiveTab] = useState("details"); // Add tab state here

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("cartItems")) || [];
    setCartItems(stored);
  }, []);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (item) => {

    const isService = item?.service;
    const isPackage = item?.package;

    let itemId = "";
    let itemType = "";

    if (isService) {
      itemId = item.service._id;
      itemType = "service";
    } else if (isPackage) {
      itemId = item.package._id;
      itemType = "package";
    } else {
      console.warn("Unknown item type. Cannot add to cart.");
      return;
    }

    setCartItems((prevItems) => {
      const alreadyInCart = prevItems.some(
        (cartItem) => cartItem._id === itemId && cartItem.type === itemType
      );
      if (alreadyInCart) return prevItems;

      return [...prevItems, { ...item, _id: itemId, type: itemType }];
    });
  };

  const updateCartItem = (id, updates) => {
    setCartItems((prev) => {
      const updated = prev.map((item) => {
        const itemId =
          item.type === "service" ? item.service._id : item.package._id;
        if (itemId === id) {
          return { ...item, ...updates };
        }
        return item;
      });
      localStorage.setItem("cartItems", JSON.stringify(updated));
      return updated;
    });
  };

  const removeFromCart = (id, type) => {
    setCartItems((prevItems) =>
      prevItems.filter((item) => !(item._id === id && item.type === type))
    );
  };

  const clearCart = () => setCartItems([]);

  // Tab function
  const changeTab = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        updateCartItem,
        activeTab,
        changeTab,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
